import React from 'react';
import ReportLayout, { StatusChip, fmtDateTime } from './ReportLayout';

const COLUMNS = [
  { key: 'qr_code', label: 'Pass ID', sortable: false },
  { key: 'visitor_name', label: 'Visitor', sortable: true },
  { key: 'visitor_type', label: 'Type', sortable: false, render: v => <StatusChip value={v} /> },
  { key: 'visitor_phone', label: 'Phone', sortable: false },
  { key: 'to_meet', label: 'Visiting', sortable: false },
  { key: 'approved_by_name', label: 'Approved By', sortable: false },
  { key: 'created_at', label: 'Generated At', render: v => fmtDateTime(v) },
  { key: 'valid_until', label: 'Valid Until', render: v => fmtDateTime(v) },
  { key: 'status', label: 'Status', sortable: true, render: v => <StatusChip value={v} /> },
  { key: 'check_in', label: 'Entry', sortable: false, render: v => fmtDateTime(v) },
];

const FILTERS = [
  {
    type: 'select',
    name: 'status',
    label: 'Status',
    defaultValue: 'all',
    options: [
      { value: 'active', label: 'Active' },
      { value: 'used', label: 'Used' },
      { value: 'expired', label: 'Expired' },
    ],
  },
  {
    type: 'select',
    name: 'visitor_type',
    label: 'Visitor Type',
    defaultValue: 'all',
    options: [
      { value: 'business', label: 'Business' },
      { value: 'vendor', label: 'Vendor' },
      { value: 'candidate', label: 'Candidate' },
      { value: 'regular', label: 'Regular' },
      { value: 'other', label: 'Other' },
    ],
  },
];

export default function VisitorGatePassReport() {
  return (
    <ReportLayout
      title="Visitor Gate Passes"
      description="All visitor gate passes generated via the approval flow"
      endpoint="/reports/visitor-gate-passes"
      columns={COLUMNS}
      filters={FILTERS}
      defaultSort="created_at"
      defaultOrder="desc"
      exportFilename="visitor-gate-passes"
    />
  );
}
